<div class="flex flex-column w-full h-screen">

    <!--<ngx-loading [show]="(loadingService.isLoading$ | async) || false"></ngx-loading>-->

    <div>
        <app-main-menu></app-main-menu>
    </div>

    <div class="m-4 flex-auto overflow-auto">
        <router-outlet></router-outlet>
    </div>

    <div class="h-2rem bg-primary">

    </div>
</div>

<!--
<footer class="footer bgc-dark text-white">
    <div class="container">
        <div class="copyright text-center flex align-items-end justify-content-center gap-2">
            <img alt="i-host" width="64" class="footer-logo" src="assets/images/logo-white.png">
            © 2014 - {{ currentDate | date: 'yyyy' }}. All rights reserved.
        </div>
    </div>
</footer>
-->